export const GET_CODED_VALUE_LIST = '/get_coded_value';
export const GET_SINGLE_CODED_VALUE = '/get_single_coded_value';
export const UPDATE_CODED_VALUE = '/update_coded_value';
export const CREATE_CODED_VALUE = '/create_coded_value';
export const REMOVE_CODED_VALUE = '/remove_coded_value';

export const FORM_DATA = {
  name: '',
  description: '',
  code: '',
  is_active: 0,
};